import { Title2 } from "@fluentui/react-components";

import { useOffice } from "../../features/office/use-office.js";

export const OfficeName = () => {
  const { team } = useOffice();

  return (
    <div className="absolute top-3 left-5 z-10">
      <Title2 className="text-bzd-gray-300">{team.name}</Title2>
    </div>
  );
};
